import moment from 'moment'

export const nowFor10Min = (m = moment()) => {
  const now = m || moment()

  return now.add(1, 'hour').minutes(0).seconds(0)
}

export const nowForHour = (m = moment()) => {
  const now = m || moment()

  return now.minutes(0).seconds(0)
}

export const nowForDate = (m = moment()) => {
  const now = m || moment()

  return now.hours(0).minutes(0).seconds(0)
}

export const now = (resolution: string, m = moment()) => {
  if (resolution === '10min') {
    return nowFor10Min(m)
  } else if (resolution === 'hourly') {
    return nowForHour(m)
  } else {
    return nowForDate(m)
  }
}
